import { useCallback } from "react";
import { capitalizeWords } from "@utils/index";
// import { validateDocument } from "@utils/cnpj";
import { cnpjConfig } from "@utils/fiscal/cnpj/config";
import useDialogAlert from "@hooks/useDialogAlert";
import { validateFiscalDocument } from "@utils/fiscal/validate";

interface CNPJItem {
  CNPJ: string;
  companyName: string;
}

interface UserFormValues {
  CNPJ?: string;
  companyName?: string;
  attributes: {
    CNPJ: CNPJItem[];
  };
}

type SetFieldValue = (field: string, value: unknown) => void;

const useAddCNPJ = (values: UserFormValues, setFieldValue: SetFieldValue) => {
  const { snackbar } = useDialogAlert();

  const addCNPJ = useCallback(() => {
    if (!values.CNPJ || !values.companyName) {
      snackbar({
        message: "Preencha o CNPJ/CPF e a Razão Social",
        variant: "warning",
      });
      return;
    }

    const cleaned = values.CNPJ.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    const { valid, message } = validateFiscalDocument(
      cleaned,
      cnpjConfig.allowAlphanumeric
    );
    if (!valid) {
      snackbar({ message, variant: "error" });
      return;
    }

    const description = cleaned.length === 14 ? "CNPJ" : "CPF";

    if (values.attributes.CNPJ.some((item) => item.CNPJ === cleaned)) {
      snackbar({
        message: `O ${description} já foi adicionado, selecione outro`,
        variant: "error",
      });
      return;
    }

    setFieldValue("attributes.CNPJ", [
      ...values.attributes.CNPJ,
      { CNPJ: cleaned, companyName: capitalizeWords(values.companyName) },
    ]);
    setFieldValue("CNPJ", "");
    setFieldValue("companyName", "");
  }, [values, setFieldValue, snackbar]);

  return addCNPJ;
};

export default useAddCNPJ;
